import React, { useContext } from 'react'
import { constants } from '../../../constants'
import { languageConstants } from '../../../constants/languageConstants'

import { LanguageContext } from '../../../context/LanguageContext'
import SelectInput from '../SelectInput'

const LanguageSelector = () => {
    const { language, languages, updateLanguage } = useContext(LanguageContext)

    if(constants.configFeatureFlags.isLanguageChangeEnabled === 'false') return null
    return (
        <SelectInput
            className="language-selector"
            value={language.toUpperCase()}
            onChange={value => {
                updateLanguage({ forcedLanguage: value })
            }}
            options={languageConstants.map(lang => lang.code)}
            name={'end'}
            size={'xs'}
        />
    )
}

export default LanguageSelector
